/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CertificationDetailDto } from '../models';
// @ts-ignore
import type { CertificationListResponseDto } from '../models';
// @ts-ignore
import type { CertificationParticipantsResponseDto } from '../models';
// @ts-ignore
import type { CertificationStatusDto } from '../models';
// @ts-ignore
import type { ChangeCertificationStatusRequestDto } from '../models';
// @ts-ignore
import type { CreateCertificationRequestDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { ParticipantFilterDictionariesDto } from '../models';
// @ts-ignore
import type { ParticipantIncludeSectionDto } from '../models';
// @ts-ignore
import type { ParticipantSortByDto } from '../models';
// @ts-ignore
import type { ParticipantStageStatusDto } from '../models';
// @ts-ignore
import type { ParticipantSurveyStatusDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
// @ts-ignore
import type { UpdateCertificationRequestDto } from '../models';
/**
 * CertificationManagementApi - axios parameter creator
 * @export
 */
export const CertificationManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Changes the certification status. Valid transitions: DRAFT -> ACTIVE, DRAFT -> CANCELLED, ACTIVE -> COMPLETED, ACTIVE -> CANCELLED. When transitioning from DRAFT to ACTIVE, certification executions are bulk-created for all participants. 
         * @summary Change certification status
         * @param {number} certificationId 
         * @param {ChangeCertificationStatusRequestDto} changeCertificationStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeCertificationStatus: async (certificationId: number, changeCertificationStatusRequestDto: ChangeCertificationStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('changeCertificationStatus', 'certificationId', certificationId)
            // verify required parameter 'changeCertificationStatusRequestDto' is not null or undefined
            assertParamExists('changeCertificationStatus', 'changeCertificationStatusRequestDto', changeCertificationStatusRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/status`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeCertificationStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new certification
         * @param {CreateCertificationRequestDto} createCertificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCertification: async (createCertificationRequestDto: CreateCertificationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCertificationRequestDto' is not null or undefined
            assertParamExists('createCertification', 'createCertificationRequestDto', createCertificationRequestDto)
            const localVarPath = `/api/v2/certifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCertificationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a certification. Only allowed when status is DRAFT. Does not delete the linked survey - only removes the association. 
         * @summary Delete certification
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCertification: async (certificationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('deleteCertification', 'certificationId', certificationId)
            const localVarPath = `/api/v2/certifications/{certificationId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the survey association from this certification. The survey itself is not deleted. Only allowed when certification status is DRAFT. 
         * @summary Detach survey from certification
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachSurvey: async (certificationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('detachSurvey', 'certificationId', certificationId)
            const localVarPath = `/api/v2/certifications/{certificationId}/survey`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get certification detail
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertificationDetail: async (certificationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getCertificationDetail', 'certificationId', certificationId)
            const localVarPath = `/api/v2/certifications/{certificationId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the list of distinct `positions`, `regions` and `examLocations` relevant for the participants view. `positions`/`regions` cover employees assigned to any stage of this certification. `examLocations` is a flat list of distinct `location` strings from the exam days of the EXAM stage (free-text, not a dictionary FK). Feeds the multi-selects (`positionCodes`, `regionCodes`, `examLocations`) in `GET /certifications/{certificationId}/participants`.  Sorting: by `name` ascending, with `code` as a stable tiebreaker (`NULLS LAST` for entries whose dictionary row is missing — in that case `name` falls back to the code). 
         * @summary Get filter dictionaries for the participants view (positions + regions + examLocations)
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertificationParticipantDictionaries: async (certificationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getCertificationParticipantDictionaries', 'certificationId', certificationId)
            const localVarPath = `/api/v2/certifications/{certificationId}/participant-dictionaries`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of employees assigned to this certification with optional per-stage aggregation (survey / test / exam). Use `include=` to opt-in stages — sections not listed are returned as `null`.  When `include=test` is set with `termId`, and/or `include=exam` is set with `examDayId`, the list of employees is narrowed to those invited to that specific term / day — and the corresponding `test.terms[]` / `exam.days[]` collection is narrowed to that item only.  Sorting: `sort` chooses the column; `sortOrder` (from commons) chooses direction. 
         * @summary Get certification participants (graph-like aggregation)
         * @param {number} certificationId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Partial match (case-insensitive) against employee &#x60;firstName&#x60;, &#x60;lastName&#x60;, &#x60;email&#x60; and &#x60;externalEmployeeId&#x60; (SAP ID). 
         * @param {Array<ParticipantIncludeSectionDto>} [include] Sections to include in the response. Sections not listed are returned as &#x60;null&#x60;. Example: &#x60;include&#x3D;SURVEY,TEST,EXAM&#x60;. 
         * @param {Array<string>} [positionCodes] Filter by &#x60;company_positions.code&#x60;. Multi-value (CSV) - OR.
         * @param {Array<string>} [regionCodes] Filter by &#x60;dict_region.code&#x60;. Multi-value (CSV) - OR.
         * @param {Array<string>} [employeeIds] Filter by employee &#x60;users.employee_id&#x60; (UUID). Multi-value (CSV) - OR. Used by exam/test stage modals to fetch full participant detail by id. 
         * @param {Array<string>} [stageTypes] Narrows the list to employees who have a &#x60;certification_stage_participant&#x60; row for any of the given stage types in this certification. Multi-value (CSV) - OR. Allowed values: SURVEY, TEST, EXAM, PLAN. Used by stage-level participants tab (e.g. exam-stage page shows only EXAM-stage participants, not all certification participants). 
         * @param {ParticipantSortByDto} [sort] Sort column. Default LAST_NAME.
         * @param {SortDirectionDto} [sortOrder] Sort direction. Default ASC.
         * @param {Array<ParticipantSurveyStatusDto>} [surveyStatus] Multi-value (CSV) - OR.
         * @param {boolean} [surveyAssigned] When set, filters employees by survey assignment presence.
         * @param {boolean} [surveyNotification] When set, filters employees by the &#x60;notification_sent&#x60; flag on their SURVEY participant record. Semantics differ from &#x60;surveyAssigned&#x60;: &#x60;false&#x60; returns ONLY employees assigned to the SURVEY stage with &#x60;notification_sent &#x3D; false&#x60; — employees without any SURVEY record are NOT returned in either variant. Typically combined with &#x60;surveyAssigned&#x3D;true&#x60;. 
         * @param {Array<ParticipantStageStatusDto>} [testStatus] Multi-value (CSV) - OR. Computed status at row level (overallStatus).
         * @param {number} [termId] Narrows the list to employees invited to this specific test term, and narrows &#x60;test.terms[]&#x60; to this item only. 
         * @param {boolean} [testPassed] 
         * @param {number} [testScoreMin] Inclusive lower bound on best test score (0-100).
         * @param {number} [testScoreMax] Inclusive upper bound on best test score (0-100).
         * @param {number} [testAttemptsMin] Inclusive lower bound on counted test attempts (status !&#x3D; NOT_STARTED).
         * @param {number} [testAttemptsMax] Inclusive upper bound on counted test attempts.
         * @param {Array<ParticipantStageStatusDto>} [examStatus] Multi-value (CSV) - OR. Computed status at row level (overallStatus).
         * @param {string} [examDayId] Narrows the list to employees invited to this specific exam day, and narrows &#x60;exam.days[]&#x60; to this item only. 
         * @param {boolean} [examPassed] 
         * @param {number} [examAttemptsMin] Inclusive lower bound on counted exam attempts (status !&#x3D; NOT_STARTED).
         * @param {number} [examAttemptsMax] Inclusive upper bound on counted exam attempts.
         * @param {Array<string>} [examLocations] Filter by exact match on &#x60;ExamDay.location&#x60;. Multi-value (CSV) - OR. Employee qualifies if any of their exam days is in any of the listed locations. 
         * @param {Array<string>} [examCommissionMemberIds] Filter by commission member &#x60;employeeId&#x60; (UUID). Multi-value (CSV) - AND. Each listed id must appear as chairman or HRBP in at least one exam day of the employee (not necessarily the same day). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertificationParticipants: async (certificationId: number, page?: number, pageSize?: number, search?: string, include?: Array<ParticipantIncludeSectionDto>, positionCodes?: Array<string>, regionCodes?: Array<string>, employeeIds?: Array<string>, stageTypes?: Array<string>, sort?: ParticipantSortByDto, sortOrder?: SortDirectionDto, surveyStatus?: Array<ParticipantSurveyStatusDto>, surveyAssigned?: boolean, surveyNotification?: boolean, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getCertificationParticipants', 'certificationId', certificationId)
            const localVarPath = `/api/v2/certifications/{certificationId}/participants`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (include) {
                localVarQueryParameter['include'] = include.join(COLLECTION_FORMATS.csv);
            }

            if (positionCodes) {
                localVarQueryParameter['positionCodes'] = positionCodes.join(COLLECTION_FORMATS.csv);
            }

            if (regionCodes) {
                localVarQueryParameter['regionCodes'] = regionCodes.join(COLLECTION_FORMATS.csv);
            }

            if (employeeIds) {
                localVarQueryParameter['employeeIds'] = employeeIds.join(COLLECTION_FORMATS.csv);
            }

            if (stageTypes) {
                localVarQueryParameter['stageTypes'] = stageTypes.join(COLLECTION_FORMATS.csv);
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (surveyStatus) {
                localVarQueryParameter['surveyStatus'] = surveyStatus.join(COLLECTION_FORMATS.csv);
            }

            if (surveyAssigned !== undefined) {
                localVarQueryParameter['surveyAssigned'] = surveyAssigned;
            }

            if (surveyNotification !== undefined) {
                localVarQueryParameter['surveyNotification'] = surveyNotification;
            }

            if (testStatus) {
                localVarQueryParameter['testStatus'] = testStatus.join(COLLECTION_FORMATS.csv);
            }

            if (termId !== undefined) {
                localVarQueryParameter['termId'] = termId;
            }

            if (testPassed !== undefined) {
                localVarQueryParameter['testPassed'] = testPassed;
            }

            if (testScoreMin !== undefined) {
                localVarQueryParameter['testScoreMin'] = testScoreMin;
            }

            if (testScoreMax !== undefined) {
                localVarQueryParameter['testScoreMax'] = testScoreMax;
            }

            if (testAttemptsMin !== undefined) {
                localVarQueryParameter['testAttemptsMin'] = testAttemptsMin;
            }

            if (testAttemptsMax !== undefined) {
                localVarQueryParameter['testAttemptsMax'] = testAttemptsMax;
            }

            if (examStatus) {
                localVarQueryParameter['examStatus'] = examStatus.join(COLLECTION_FORMATS.csv);
            }

            if (examDayId !== undefined) {
                localVarQueryParameter['examDayId'] = examDayId;
            }

            if (examPassed !== undefined) {
                localVarQueryParameter['examPassed'] = examPassed;
            }

            if (examAttemptsMin !== undefined) {
                localVarQueryParameter['examAttemptsMin'] = examAttemptsMin;
            }

            if (examAttemptsMax !== undefined) {
                localVarQueryParameter['examAttemptsMax'] = examAttemptsMax;
            }

            if (examLocations) {
                localVarQueryParameter['examLocations'] = examLocations.join(COLLECTION_FORMATS.csv);
            }

            if (examCommissionMemberIds) {
                localVarQueryParameter['examCommissionMemberIds'] = examCommissionMemberIds.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all certifications with pagination
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by certification name (partial match)
         * @param {CertificationStatusDto} [status] Filter by certification status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertifications: async (page?: number, pageSize?: number, search?: string, status?: CertificationStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/certifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates certification properties. All fields are optional. Status transitions: DRAFT -> ACTIVE -> COMPLETED / CANCELLED. 
         * @summary Update certification
         * @param {number} certificationId 
         * @param {UpdateCertificationRequestDto} updateCertificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCertification: async (certificationId: number, updateCertificationRequestDto: UpdateCertificationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('updateCertification', 'certificationId', certificationId)
            // verify required parameter 'updateCertificationRequestDto' is not null or undefined
            assertParamExists('updateCertification', 'updateCertificationRequestDto', updateCertificationRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCertificationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CertificationManagementApi - functional programming interface
 * @export
 */
export const CertificationManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CertificationManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Changes the certification status. Valid transitions: DRAFT -> ACTIVE, DRAFT -> CANCELLED, ACTIVE -> COMPLETED, ACTIVE -> CANCELLED. When transitioning from DRAFT to ACTIVE, certification executions are bulk-created for all participants. 
         * @summary Change certification status
         * @param {number} certificationId 
         * @param {ChangeCertificationStatusRequestDto} changeCertificationStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeCertificationStatus(certificationId: number, changeCertificationStatusRequestDto: ChangeCertificationStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificationDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeCertificationStatus(certificationId, changeCertificationStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationManagementApi.changeCertificationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new certification
         * @param {CreateCertificationRequestDto} createCertificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCertification(createCertificationRequestDto: CreateCertificationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificationDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCertification(createCertificationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationManagementApi.createCertification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a certification. Only allowed when status is DRAFT. Does not delete the linked survey - only removes the association. 
         * @summary Delete certification
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCertification(certificationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCertification(certificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationManagementApi.deleteCertification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes the survey association from this certification. The survey itself is not deleted. Only allowed when certification status is DRAFT. 
         * @summary Detach survey from certification
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detachSurvey(certificationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificationDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detachSurvey(certificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationManagementApi.detachSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get certification detail
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCertificationDetail(certificationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificationDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCertificationDetail(certificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationManagementApi.getCertificationDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the list of distinct `positions`, `regions` and `examLocations` relevant for the participants view. `positions`/`regions` cover employees assigned to any stage of this certification. `examLocations` is a flat list of distinct `location` strings from the exam days of the EXAM stage (free-text, not a dictionary FK). Feeds the multi-selects (`positionCodes`, `regionCodes`, `examLocations`) in `GET /certifications/{certificationId}/participants`.  Sorting: by `name` ascending, with `code` as a stable tiebreaker (`NULLS LAST` for entries whose dictionary row is missing — in that case `name` falls back to the code). 
         * @summary Get filter dictionaries for the participants view (positions + regions + examLocations)
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCertificationParticipantDictionaries(certificationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParticipantFilterDictionariesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCertificationParticipantDictionaries(certificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationManagementApi.getCertificationParticipantDictionaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of employees assigned to this certification with optional per-stage aggregation (survey / test / exam). Use `include=` to opt-in stages — sections not listed are returned as `null`.  When `include=test` is set with `termId`, and/or `include=exam` is set with `examDayId`, the list of employees is narrowed to those invited to that specific term / day — and the corresponding `test.terms[]` / `exam.days[]` collection is narrowed to that item only.  Sorting: `sort` chooses the column; `sortOrder` (from commons) chooses direction. 
         * @summary Get certification participants (graph-like aggregation)
         * @param {number} certificationId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Partial match (case-insensitive) against employee &#x60;firstName&#x60;, &#x60;lastName&#x60;, &#x60;email&#x60; and &#x60;externalEmployeeId&#x60; (SAP ID). 
         * @param {Array<ParticipantIncludeSectionDto>} [include] Sections to include in the response. Sections not listed are returned as &#x60;null&#x60;. Example: &#x60;include&#x3D;SURVEY,TEST,EXAM&#x60;. 
         * @param {Array<string>} [positionCodes] Filter by &#x60;company_positions.code&#x60;. Multi-value (CSV) - OR.
         * @param {Array<string>} [regionCodes] Filter by &#x60;dict_region.code&#x60;. Multi-value (CSV) - OR.
         * @param {Array<string>} [employeeIds] Filter by employee &#x60;users.employee_id&#x60; (UUID). Multi-value (CSV) - OR. Used by exam/test stage modals to fetch full participant detail by id. 
         * @param {Array<string>} [stageTypes] Narrows the list to employees who have a &#x60;certification_stage_participant&#x60; row for any of the given stage types in this certification. Multi-value (CSV) - OR. Allowed values: SURVEY, TEST, EXAM, PLAN. Used by stage-level participants tab (e.g. exam-stage page shows only EXAM-stage participants, not all certification participants). 
         * @param {ParticipantSortByDto} [sort] Sort column. Default LAST_NAME.
         * @param {SortDirectionDto} [sortOrder] Sort direction. Default ASC.
         * @param {Array<ParticipantSurveyStatusDto>} [surveyStatus] Multi-value (CSV) - OR.
         * @param {boolean} [surveyAssigned] When set, filters employees by survey assignment presence.
         * @param {boolean} [surveyNotification] When set, filters employees by the &#x60;notification_sent&#x60; flag on their SURVEY participant record. Semantics differ from &#x60;surveyAssigned&#x60;: &#x60;false&#x60; returns ONLY employees assigned to the SURVEY stage with &#x60;notification_sent &#x3D; false&#x60; — employees without any SURVEY record are NOT returned in either variant. Typically combined with &#x60;surveyAssigned&#x3D;true&#x60;. 
         * @param {Array<ParticipantStageStatusDto>} [testStatus] Multi-value (CSV) - OR. Computed status at row level (overallStatus).
         * @param {number} [termId] Narrows the list to employees invited to this specific test term, and narrows &#x60;test.terms[]&#x60; to this item only. 
         * @param {boolean} [testPassed] 
         * @param {number} [testScoreMin] Inclusive lower bound on best test score (0-100).
         * @param {number} [testScoreMax] Inclusive upper bound on best test score (0-100).
         * @param {number} [testAttemptsMin] Inclusive lower bound on counted test attempts (status !&#x3D; NOT_STARTED).
         * @param {number} [testAttemptsMax] Inclusive upper bound on counted test attempts.
         * @param {Array<ParticipantStageStatusDto>} [examStatus] Multi-value (CSV) - OR. Computed status at row level (overallStatus).
         * @param {string} [examDayId] Narrows the list to employees invited to this specific exam day, and narrows &#x60;exam.days[]&#x60; to this item only. 
         * @param {boolean} [examPassed] 
         * @param {number} [examAttemptsMin] Inclusive lower bound on counted exam attempts (status !&#x3D; NOT_STARTED).
         * @param {number} [examAttemptsMax] Inclusive upper bound on counted exam attempts.
         * @param {Array<string>} [examLocations] Filter by exact match on &#x60;ExamDay.location&#x60;. Multi-value (CSV) - OR. Employee qualifies if any of their exam days is in any of the listed locations. 
         * @param {Array<string>} [examCommissionMemberIds] Filter by commission member &#x60;employeeId&#x60; (UUID). Multi-value (CSV) - AND. Each listed id must appear as chairman or HRBP in at least one exam day of the employee (not necessarily the same day). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCertificationParticipants(certificationId: number, page?: number, pageSize?: number, search?: string, include?: Array<ParticipantIncludeSectionDto>, positionCodes?: Array<string>, regionCodes?: Array<string>, employeeIds?: Array<string>, stageTypes?: Array<string>, sort?: ParticipantSortByDto, sortOrder?: SortDirectionDto, surveyStatus?: Array<ParticipantSurveyStatusDto>, surveyAssigned?: boolean, surveyNotification?: boolean, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificationParticipantsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCertificationParticipants(certificationId, page, pageSize, search, include, positionCodes, regionCodes, employeeIds, stageTypes, sort, sortOrder, surveyStatus, surveyAssigned, surveyNotification, testStatus, termId, testPassed, testScoreMin, testScoreMax, testAttemptsMin, testAttemptsMax, examStatus, examDayId, examPassed, examAttemptsMin, examAttemptsMax, examLocations, examCommissionMemberIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationManagementApi.getCertificationParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all certifications with pagination
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by certification name (partial match)
         * @param {CertificationStatusDto} [status] Filter by certification status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCertifications(page?: number, pageSize?: number, search?: string, status?: CertificationStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificationListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCertifications(page, pageSize, search, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationManagementApi.getCertifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates certification properties. All fields are optional. Status transitions: DRAFT -> ACTIVE -> COMPLETED / CANCELLED. 
         * @summary Update certification
         * @param {number} certificationId 
         * @param {UpdateCertificationRequestDto} updateCertificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCertification(certificationId: number, updateCertificationRequestDto: UpdateCertificationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificationDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCertification(certificationId, updateCertificationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificationManagementApi.updateCertification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CertificationManagementApi - factory interface
 * @export
 */
export const CertificationManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CertificationManagementApiFp(configuration)
    return {
        /**
         * Changes the certification status. Valid transitions: DRAFT -> ACTIVE, DRAFT -> CANCELLED, ACTIVE -> COMPLETED, ACTIVE -> CANCELLED. When transitioning from DRAFT to ACTIVE, certification executions are bulk-created for all participants. 
         * @summary Change certification status
         * @param {number} certificationId 
         * @param {ChangeCertificationStatusRequestDto} changeCertificationStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeCertificationStatus(certificationId: number, changeCertificationStatusRequestDto: ChangeCertificationStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto> {
            return localVarFp.changeCertificationStatus(certificationId, changeCertificationStatusRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new certification
         * @param {CreateCertificationRequestDto} createCertificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCertification(createCertificationRequestDto: CreateCertificationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto> {
            return localVarFp.createCertification(createCertificationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a certification. Only allowed when status is DRAFT. Does not delete the linked survey - only removes the association. 
         * @summary Delete certification
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCertification(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCertification(certificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the survey association from this certification. The survey itself is not deleted. Only allowed when certification status is DRAFT. 
         * @summary Detach survey from certification
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachSurvey(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto> {
            return localVarFp.detachSurvey(certificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get certification detail
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertificationDetail(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto> {
            return localVarFp.getCertificationDetail(certificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the list of distinct `positions`, `regions` and `examLocations` relevant for the participants view. `positions`/`regions` cover employees assigned to any stage of this certification. `examLocations` is a flat list of distinct `location` strings from the exam days of the EXAM stage (free-text, not a dictionary FK). Feeds the multi-selects (`positionCodes`, `regionCodes`, `examLocations`) in `GET /certifications/{certificationId}/participants`.  Sorting: by `name` ascending, with `code` as a stable tiebreaker (`NULLS LAST` for entries whose dictionary row is missing — in that case `name` falls back to the code). 
         * @summary Get filter dictionaries for the participants view (positions + regions + examLocations)
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertificationParticipantDictionaries(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<ParticipantFilterDictionariesDto> {
            return localVarFp.getCertificationParticipantDictionaries(certificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of employees assigned to this certification with optional per-stage aggregation (survey / test / exam). Use `include=` to opt-in stages — sections not listed are returned as `null`.  When `include=test` is set with `termId`, and/or `include=exam` is set with `examDayId`, the list of employees is narrowed to those invited to that specific term / day — and the corresponding `test.terms[]` / `exam.days[]` collection is narrowed to that item only.  Sorting: `sort` chooses the column; `sortOrder` (from commons) chooses direction. 
         * @summary Get certification participants (graph-like aggregation)
         * @param {number} certificationId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Partial match (case-insensitive) against employee &#x60;firstName&#x60;, &#x60;lastName&#x60;, &#x60;email&#x60; and &#x60;externalEmployeeId&#x60; (SAP ID). 
         * @param {Array<ParticipantIncludeSectionDto>} [include] Sections to include in the response. Sections not listed are returned as &#x60;null&#x60;. Example: &#x60;include&#x3D;SURVEY,TEST,EXAM&#x60;. 
         * @param {Array<string>} [positionCodes] Filter by &#x60;company_positions.code&#x60;. Multi-value (CSV) - OR.
         * @param {Array<string>} [regionCodes] Filter by &#x60;dict_region.code&#x60;. Multi-value (CSV) - OR.
         * @param {Array<string>} [employeeIds] Filter by employee &#x60;users.employee_id&#x60; (UUID). Multi-value (CSV) - OR. Used by exam/test stage modals to fetch full participant detail by id. 
         * @param {Array<string>} [stageTypes] Narrows the list to employees who have a &#x60;certification_stage_participant&#x60; row for any of the given stage types in this certification. Multi-value (CSV) - OR. Allowed values: SURVEY, TEST, EXAM, PLAN. Used by stage-level participants tab (e.g. exam-stage page shows only EXAM-stage participants, not all certification participants). 
         * @param {ParticipantSortByDto} [sort] Sort column. Default LAST_NAME.
         * @param {SortDirectionDto} [sortOrder] Sort direction. Default ASC.
         * @param {Array<ParticipantSurveyStatusDto>} [surveyStatus] Multi-value (CSV) - OR.
         * @param {boolean} [surveyAssigned] When set, filters employees by survey assignment presence.
         * @param {boolean} [surveyNotification] When set, filters employees by the &#x60;notification_sent&#x60; flag on their SURVEY participant record. Semantics differ from &#x60;surveyAssigned&#x60;: &#x60;false&#x60; returns ONLY employees assigned to the SURVEY stage with &#x60;notification_sent &#x3D; false&#x60; — employees without any SURVEY record are NOT returned in either variant. Typically combined with &#x60;surveyAssigned&#x3D;true&#x60;. 
         * @param {Array<ParticipantStageStatusDto>} [testStatus] Multi-value (CSV) - OR. Computed status at row level (overallStatus).
         * @param {number} [termId] Narrows the list to employees invited to this specific test term, and narrows &#x60;test.terms[]&#x60; to this item only. 
         * @param {boolean} [testPassed] 
         * @param {number} [testScoreMin] Inclusive lower bound on best test score (0-100).
         * @param {number} [testScoreMax] Inclusive upper bound on best test score (0-100).
         * @param {number} [testAttemptsMin] Inclusive lower bound on counted test attempts (status !&#x3D; NOT_STARTED).
         * @param {number} [testAttemptsMax] Inclusive upper bound on counted test attempts.
         * @param {Array<ParticipantStageStatusDto>} [examStatus] Multi-value (CSV) - OR. Computed status at row level (overallStatus).
         * @param {string} [examDayId] Narrows the list to employees invited to this specific exam day, and narrows &#x60;exam.days[]&#x60; to this item only. 
         * @param {boolean} [examPassed] 
         * @param {number} [examAttemptsMin] Inclusive lower bound on counted exam attempts (status !&#x3D; NOT_STARTED).
         * @param {number} [examAttemptsMax] Inclusive upper bound on counted exam attempts.
         * @param {Array<string>} [examLocations] Filter by exact match on &#x60;ExamDay.location&#x60;. Multi-value (CSV) - OR. Employee qualifies if any of their exam days is in any of the listed locations. 
         * @param {Array<string>} [examCommissionMemberIds] Filter by commission member &#x60;employeeId&#x60; (UUID). Multi-value (CSV) - AND. Each listed id must appear as chairman or HRBP in at least one exam day of the employee (not necessarily the same day). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertificationParticipants(certificationId: number, page?: number, pageSize?: number, search?: string, include?: Array<ParticipantIncludeSectionDto>, positionCodes?: Array<string>, regionCodes?: Array<string>, employeeIds?: Array<string>, stageTypes?: Array<string>, sort?: ParticipantSortByDto, sortOrder?: SortDirectionDto, surveyStatus?: Array<ParticipantSurveyStatusDto>, surveyAssigned?: boolean, surveyNotification?: boolean, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<CertificationParticipantsResponseDto> {
            return localVarFp.getCertificationParticipants(certificationId, page, pageSize, search, include, positionCodes, regionCodes, employeeIds, stageTypes, sort, sortOrder, surveyStatus, surveyAssigned, surveyNotification, testStatus, termId, testPassed, testScoreMin, testScoreMax, testAttemptsMin, testAttemptsMax, examStatus, examDayId, examPassed, examAttemptsMin, examAttemptsMax, examLocations, examCommissionMemberIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all certifications with pagination
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by certification name (partial match)
         * @param {CertificationStatusDto} [status] Filter by certification status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertifications(page?: number, pageSize?: number, search?: string, status?: CertificationStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<CertificationListResponseDto> {
            return localVarFp.getCertifications(page, pageSize, search, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates certification properties. All fields are optional. Status transitions: DRAFT -> ACTIVE -> COMPLETED / CANCELLED. 
         * @summary Update certification
         * @param {number} certificationId 
         * @param {UpdateCertificationRequestDto} updateCertificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCertification(certificationId: number, updateCertificationRequestDto: UpdateCertificationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto> {
            return localVarFp.updateCertification(certificationId, updateCertificationRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CertificationManagementApi - interface
 * @export
 * @interface CertificationManagementApi
 */
export interface CertificationManagementApiInterface {
    /**
     * Changes the certification status. Valid transitions: DRAFT -> ACTIVE, DRAFT -> CANCELLED, ACTIVE -> COMPLETED, ACTIVE -> CANCELLED. When transitioning from DRAFT to ACTIVE, certification executions are bulk-created for all participants. 
     * @summary Change certification status
     * @param {number} certificationId 
     * @param {ChangeCertificationStatusRequestDto} changeCertificationStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApiInterface
     */
    changeCertificationStatus(certificationId: number, changeCertificationStatusRequestDto: ChangeCertificationStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto>;

    /**
     * 
     * @summary Create a new certification
     * @param {CreateCertificationRequestDto} createCertificationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApiInterface
     */
    createCertification(createCertificationRequestDto: CreateCertificationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto>;

    /**
     * Deletes a certification. Only allowed when status is DRAFT. Does not delete the linked survey - only removes the association. 
     * @summary Delete certification
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApiInterface
     */
    deleteCertification(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Removes the survey association from this certification. The survey itself is not deleted. Only allowed when certification status is DRAFT. 
     * @summary Detach survey from certification
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApiInterface
     */
    detachSurvey(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto>;

    /**
     * 
     * @summary Get certification detail
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApiInterface
     */
    getCertificationDetail(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto>;

    /**
     * Returns the list of distinct `positions`, `regions` and `examLocations` relevant for the participants view. `positions`/`regions` cover employees assigned to any stage of this certification. `examLocations` is a flat list of distinct `location` strings from the exam days of the EXAM stage (free-text, not a dictionary FK). Feeds the multi-selects (`positionCodes`, `regionCodes`, `examLocations`) in `GET /certifications/{certificationId}/participants`.  Sorting: by `name` ascending, with `code` as a stable tiebreaker (`NULLS LAST` for entries whose dictionary row is missing — in that case `name` falls back to the code). 
     * @summary Get filter dictionaries for the participants view (positions + regions + examLocations)
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApiInterface
     */
    getCertificationParticipantDictionaries(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<ParticipantFilterDictionariesDto>;

    /**
     * Returns paginated list of employees assigned to this certification with optional per-stage aggregation (survey / test / exam). Use `include=` to opt-in stages — sections not listed are returned as `null`.  When `include=test` is set with `termId`, and/or `include=exam` is set with `examDayId`, the list of employees is narrowed to those invited to that specific term / day — and the corresponding `test.terms[]` / `exam.days[]` collection is narrowed to that item only.  Sorting: `sort` chooses the column; `sortOrder` (from commons) chooses direction. 
     * @summary Get certification participants (graph-like aggregation)
     * @param {number} certificationId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Partial match (case-insensitive) against employee &#x60;firstName&#x60;, &#x60;lastName&#x60;, &#x60;email&#x60; and &#x60;externalEmployeeId&#x60; (SAP ID). 
     * @param {Array<ParticipantIncludeSectionDto>} [include] Sections to include in the response. Sections not listed are returned as &#x60;null&#x60;. Example: &#x60;include&#x3D;SURVEY,TEST,EXAM&#x60;. 
     * @param {Array<string>} [positionCodes] Filter by &#x60;company_positions.code&#x60;. Multi-value (CSV) - OR.
     * @param {Array<string>} [regionCodes] Filter by &#x60;dict_region.code&#x60;. Multi-value (CSV) - OR.
     * @param {Array<string>} [employeeIds] Filter by employee &#x60;users.employee_id&#x60; (UUID). Multi-value (CSV) - OR. Used by exam/test stage modals to fetch full participant detail by id. 
     * @param {Array<string>} [stageTypes] Narrows the list to employees who have a &#x60;certification_stage_participant&#x60; row for any of the given stage types in this certification. Multi-value (CSV) - OR. Allowed values: SURVEY, TEST, EXAM, PLAN. Used by stage-level participants tab (e.g. exam-stage page shows only EXAM-stage participants, not all certification participants). 
     * @param {ParticipantSortByDto} [sort] Sort column. Default LAST_NAME.
     * @param {SortDirectionDto} [sortOrder] Sort direction. Default ASC.
     * @param {Array<ParticipantSurveyStatusDto>} [surveyStatus] Multi-value (CSV) - OR.
     * @param {boolean} [surveyAssigned] When set, filters employees by survey assignment presence.
     * @param {boolean} [surveyNotification] When set, filters employees by the &#x60;notification_sent&#x60; flag on their SURVEY participant record. Semantics differ from &#x60;surveyAssigned&#x60;: &#x60;false&#x60; returns ONLY employees assigned to the SURVEY stage with &#x60;notification_sent &#x3D; false&#x60; — employees without any SURVEY record are NOT returned in either variant. Typically combined with &#x60;surveyAssigned&#x3D;true&#x60;. 
     * @param {Array<ParticipantStageStatusDto>} [testStatus] Multi-value (CSV) - OR. Computed status at row level (overallStatus).
     * @param {number} [termId] Narrows the list to employees invited to this specific test term, and narrows &#x60;test.terms[]&#x60; to this item only. 
     * @param {boolean} [testPassed] 
     * @param {number} [testScoreMin] Inclusive lower bound on best test score (0-100).
     * @param {number} [testScoreMax] Inclusive upper bound on best test score (0-100).
     * @param {number} [testAttemptsMin] Inclusive lower bound on counted test attempts (status !&#x3D; NOT_STARTED).
     * @param {number} [testAttemptsMax] Inclusive upper bound on counted test attempts.
     * @param {Array<ParticipantStageStatusDto>} [examStatus] Multi-value (CSV) - OR. Computed status at row level (overallStatus).
     * @param {string} [examDayId] Narrows the list to employees invited to this specific exam day, and narrows &#x60;exam.days[]&#x60; to this item only. 
     * @param {boolean} [examPassed] 
     * @param {number} [examAttemptsMin] Inclusive lower bound on counted exam attempts (status !&#x3D; NOT_STARTED).
     * @param {number} [examAttemptsMax] Inclusive upper bound on counted exam attempts.
     * @param {Array<string>} [examLocations] Filter by exact match on &#x60;ExamDay.location&#x60;. Multi-value (CSV) - OR. Employee qualifies if any of their exam days is in any of the listed locations. 
     * @param {Array<string>} [examCommissionMemberIds] Filter by commission member &#x60;employeeId&#x60; (UUID). Multi-value (CSV) - AND. Each listed id must appear as chairman or HRBP in at least one exam day of the employee (not necessarily the same day). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApiInterface
     */
    getCertificationParticipants(certificationId: number, page?: number, pageSize?: number, search?: string, include?: Array<ParticipantIncludeSectionDto>, positionCodes?: Array<string>, regionCodes?: Array<string>, employeeIds?: Array<string>, stageTypes?: Array<string>, sort?: ParticipantSortByDto, sortOrder?: SortDirectionDto, surveyStatus?: Array<ParticipantSurveyStatusDto>, surveyAssigned?: boolean, surveyNotification?: boolean, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<CertificationParticipantsResponseDto>;

    /**
     * 
     * @summary Get all certifications with pagination
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Filter by certification name (partial match)
     * @param {CertificationStatusDto} [status] Filter by certification status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApiInterface
     */
    getCertifications(page?: number, pageSize?: number, search?: string, status?: CertificationStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<CertificationListResponseDto>;

    /**
     * Updates certification properties. All fields are optional. Status transitions: DRAFT -> ACTIVE -> COMPLETED / CANCELLED. 
     * @summary Update certification
     * @param {number} certificationId 
     * @param {UpdateCertificationRequestDto} updateCertificationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApiInterface
     */
    updateCertification(certificationId: number, updateCertificationRequestDto: UpdateCertificationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CertificationDetailDto>;

}

/**
 * CertificationManagementApi - object-oriented interface
 * @export
 * @class CertificationManagementApi
 * @extends {BaseAPI}
 */
export class CertificationManagementApi extends BaseAPI implements CertificationManagementApiInterface {
    /**
     * Changes the certification status. Valid transitions: DRAFT -> ACTIVE, DRAFT -> CANCELLED, ACTIVE -> COMPLETED, ACTIVE -> CANCELLED. When transitioning from DRAFT to ACTIVE, certification executions are bulk-created for all participants. 
     * @summary Change certification status
     * @param {number} certificationId 
     * @param {ChangeCertificationStatusRequestDto} changeCertificationStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApi
     */
    public changeCertificationStatus(certificationId: number, changeCertificationStatusRequestDto: ChangeCertificationStatusRequestDto, options?: RawAxiosRequestConfig) {
        return CertificationManagementApiFp(this.configuration).changeCertificationStatus(certificationId, changeCertificationStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new certification
     * @param {CreateCertificationRequestDto} createCertificationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApi
     */
    public createCertification(createCertificationRequestDto: CreateCertificationRequestDto, options?: RawAxiosRequestConfig) {
        return CertificationManagementApiFp(this.configuration).createCertification(createCertificationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a certification. Only allowed when status is DRAFT. Does not delete the linked survey - only removes the association. 
     * @summary Delete certification
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApi
     */
    public deleteCertification(certificationId: number, options?: RawAxiosRequestConfig) {
        return CertificationManagementApiFp(this.configuration).deleteCertification(certificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes the survey association from this certification. The survey itself is not deleted. Only allowed when certification status is DRAFT. 
     * @summary Detach survey from certification
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApi
     */
    public detachSurvey(certificationId: number, options?: RawAxiosRequestConfig) {
        return CertificationManagementApiFp(this.configuration).detachSurvey(certificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get certification detail
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApi
     */
    public getCertificationDetail(certificationId: number, options?: RawAxiosRequestConfig) {
        return CertificationManagementApiFp(this.configuration).getCertificationDetail(certificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the list of distinct `positions`, `regions` and `examLocations` relevant for the participants view. `positions`/`regions` cover employees assigned to any stage of this certification. `examLocations` is a flat list of distinct `location` strings from the exam days of the EXAM stage (free-text, not a dictionary FK). Feeds the multi-selects (`positionCodes`, `regionCodes`, `examLocations`) in `GET /certifications/{certificationId}/participants`.  Sorting: by `name` ascending, with `code` as a stable tiebreaker (`NULLS LAST` for entries whose dictionary row is missing — in that case `name` falls back to the code). 
     * @summary Get filter dictionaries for the participants view (positions + regions + examLocations)
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApi
     */
    public getCertificationParticipantDictionaries(certificationId: number, options?: RawAxiosRequestConfig) {
        return CertificationManagementApiFp(this.configuration).getCertificationParticipantDictionaries(certificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of employees assigned to this certification with optional per-stage aggregation (survey / test / exam). Use `include=` to opt-in stages — sections not listed are returned as `null`.  When `include=test` is set with `termId`, and/or `include=exam` is set with `examDayId`, the list of employees is narrowed to those invited to that specific term / day — and the corresponding `test.terms[]` / `exam.days[]` collection is narrowed to that item only.  Sorting: `sort` chooses the column; `sortOrder` (from commons) chooses direction. 
     * @summary Get certification participants (graph-like aggregation)
     * @param {number} certificationId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Partial match (case-insensitive) against employee &#x60;firstName&#x60;, &#x60;lastName&#x60;, &#x60;email&#x60; and &#x60;externalEmployeeId&#x60; (SAP ID). 
     * @param {Array<ParticipantIncludeSectionDto>} [include] Sections to include in the response. Sections not listed are returned as &#x60;null&#x60;. Example: &#x60;include&#x3D;SURVEY,TEST,EXAM&#x60;. 
     * @param {Array<string>} [positionCodes] Filter by &#x60;company_positions.code&#x60;. Multi-value (CSV) - OR.
     * @param {Array<string>} [regionCodes] Filter by &#x60;dict_region.code&#x60;. Multi-value (CSV) - OR.
     * @param {Array<string>} [employeeIds] Filter by employee &#x60;users.employee_id&#x60; (UUID). Multi-value (CSV) - OR. Used by exam/test stage modals to fetch full participant detail by id. 
     * @param {Array<string>} [stageTypes] Narrows the list to employees who have a &#x60;certification_stage_participant&#x60; row for any of the given stage types in this certification. Multi-value (CSV) - OR. Allowed values: SURVEY, TEST, EXAM, PLAN. Used by stage-level participants tab (e.g. exam-stage page shows only EXAM-stage participants, not all certification participants). 
     * @param {ParticipantSortByDto} [sort] Sort column. Default LAST_NAME.
     * @param {SortDirectionDto} [sortOrder] Sort direction. Default ASC.
     * @param {Array<ParticipantSurveyStatusDto>} [surveyStatus] Multi-value (CSV) - OR.
     * @param {boolean} [surveyAssigned] When set, filters employees by survey assignment presence.
     * @param {boolean} [surveyNotification] When set, filters employees by the &#x60;notification_sent&#x60; flag on their SURVEY participant record. Semantics differ from &#x60;surveyAssigned&#x60;: &#x60;false&#x60; returns ONLY employees assigned to the SURVEY stage with &#x60;notification_sent &#x3D; false&#x60; — employees without any SURVEY record are NOT returned in either variant. Typically combined with &#x60;surveyAssigned&#x3D;true&#x60;. 
     * @param {Array<ParticipantStageStatusDto>} [testStatus] Multi-value (CSV) - OR. Computed status at row level (overallStatus).
     * @param {number} [termId] Narrows the list to employees invited to this specific test term, and narrows &#x60;test.terms[]&#x60; to this item only. 
     * @param {boolean} [testPassed] 
     * @param {number} [testScoreMin] Inclusive lower bound on best test score (0-100).
     * @param {number} [testScoreMax] Inclusive upper bound on best test score (0-100).
     * @param {number} [testAttemptsMin] Inclusive lower bound on counted test attempts (status !&#x3D; NOT_STARTED).
     * @param {number} [testAttemptsMax] Inclusive upper bound on counted test attempts.
     * @param {Array<ParticipantStageStatusDto>} [examStatus] Multi-value (CSV) - OR. Computed status at row level (overallStatus).
     * @param {string} [examDayId] Narrows the list to employees invited to this specific exam day, and narrows &#x60;exam.days[]&#x60; to this item only. 
     * @param {boolean} [examPassed] 
     * @param {number} [examAttemptsMin] Inclusive lower bound on counted exam attempts (status !&#x3D; NOT_STARTED).
     * @param {number} [examAttemptsMax] Inclusive upper bound on counted exam attempts.
     * @param {Array<string>} [examLocations] Filter by exact match on &#x60;ExamDay.location&#x60;. Multi-value (CSV) - OR. Employee qualifies if any of their exam days is in any of the listed locations. 
     * @param {Array<string>} [examCommissionMemberIds] Filter by commission member &#x60;employeeId&#x60; (UUID). Multi-value (CSV) - AND. Each listed id must appear as chairman or HRBP in at least one exam day of the employee (not necessarily the same day). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApi
     */
    public getCertificationParticipants(certificationId: number, page?: number, pageSize?: number, search?: string, include?: Array<ParticipantIncludeSectionDto>, positionCodes?: Array<string>, regionCodes?: Array<string>, employeeIds?: Array<string>, stageTypes?: Array<string>, sort?: ParticipantSortByDto, sortOrder?: SortDirectionDto, surveyStatus?: Array<ParticipantSurveyStatusDto>, surveyAssigned?: boolean, surveyNotification?: boolean, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, examStatus?: Array<ParticipantStageStatusDto>, examDayId?: string, examPassed?: boolean, examAttemptsMin?: number, examAttemptsMax?: number, examLocations?: Array<string>, examCommissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig) {
        return CertificationManagementApiFp(this.configuration).getCertificationParticipants(certificationId, page, pageSize, search, include, positionCodes, regionCodes, employeeIds, stageTypes, sort, sortOrder, surveyStatus, surveyAssigned, surveyNotification, testStatus, termId, testPassed, testScoreMin, testScoreMax, testAttemptsMin, testAttemptsMax, examStatus, examDayId, examPassed, examAttemptsMin, examAttemptsMax, examLocations, examCommissionMemberIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all certifications with pagination
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Filter by certification name (partial match)
     * @param {CertificationStatusDto} [status] Filter by certification status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApi
     */
    public getCertifications(page?: number, pageSize?: number, search?: string, status?: CertificationStatusDto, options?: RawAxiosRequestConfig) {
        return CertificationManagementApiFp(this.configuration).getCertifications(page, pageSize, search, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates certification properties. All fields are optional. Status transitions: DRAFT -> ACTIVE -> COMPLETED / CANCELLED. 
     * @summary Update certification
     * @param {number} certificationId 
     * @param {UpdateCertificationRequestDto} updateCertificationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificationManagementApi
     */
    public updateCertification(certificationId: number, updateCertificationRequestDto: UpdateCertificationRequestDto, options?: RawAxiosRequestConfig) {
        return CertificationManagementApiFp(this.configuration).updateCertification(certificationId, updateCertificationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

